import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useGet } from "../../customHooks/useGet";
import { useAuthProvider } from "../../customHooks/authContext";
import { Container, Table, Alert, Button } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; 
import "bootstrap/dist/css/bootstrap.min.css";
import { get } from "../../services/Services";
import { Card } from "react-bootstrap";

const Payments = () => {
  const location = useLocation();
  const { eventRegistrationId, configId } = location.state || {};
  const { token } = useAuthProvider();
  const { school } = useAuthProvider();
  const { config } = useAuthProvider();
  const schoolId = school?.id;
  
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(100);
  const [showHelpMessage, setShowHelpMessage] = useState(true);
  const [coursesData, setCoursesData] = useState(null);
  const [showPartialModal, setShowPartialModal] = useState(false);
const [partialAmount, setPartialAmount] = useState("");
const [paymentConditions, setPaymentConditions] = useState(null);

const { data: paymentConditionsData } = useGet(
  configId 
    ? `https://ectech-software.com.ar/api/academy/events/${configId}/payment-condition/all`
    : null,
  { headers: { Authorization: `Bearer ${token}` } }
);


useEffect(() => {
  if (paymentConditionsData) {
    setPaymentConditions(paymentConditionsData); // Ahora es un array
  }
}, [paymentConditionsData]);


const { endDate, discountPercentage, interestPercentage, minPerformances } = paymentConditions || {};

const calcularPago = (condicion) => {
  let amount = totalGeneral;
  let description = "Pago normal";

  const obrasAjustadas = noBecadas.length >= condicion.minPerformances; 

  // Convertir fecha de endDate en objeto Date
  const hoy = new Date();
  const fechaLimite = new Date(condicion.endDate);
  const fechaValida = hoy <= fechaLimite;

  // Si cumple condición de descuento (cantidad + fecha válida)
  if (obrasAjustadas && fechaValida && condicion.discountPercentage > 0) {
    amount = totalObras * (1 - condicion.discountPercentage / 100) + totalCursos;
    description = `Pago con ${condicion.discountPercentage}% de descuento (aplica a ${condicion.minPerformances} obras o más hasta el ${fechaLimite.toLocaleDateString()})`;
  } 
  // Si tiene recargo
  else if (condicion.interestPercentage > 0) {
    amount = totalGeneral * (1 + condicion.interestPercentage / 100);
    description = `Pago con ${condicion.interestPercentage}% de recargo`;
  } 
  // Si es pago normal
  else if (condicion.discountPercentage === 0 && condicion.interestPercentage === 0) {
    amount = totalGeneral;
    description = "Pago normal sin descuento ni recargo";
  } 
  // Si no tiene datos válidos (oculta tarjeta)
  else {
    return { amount: undefined, description: undefined };
  }

  return { amount, description };
};

  // Obtener performancesData
  const { data: performancesData, refetch } = useGet(
    eventRegistrationId
      ? `https://ectech-software.com.ar/api/academy/events/registration/${eventRegistrationId}/performance?page=${page}&size=${size}`
      : null,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const totalPages = performancesData?.totalPages || 1;

  // Obtener cursos (seminarios)
  useEffect(() => {
    console.log("schoolId:", schoolId, "eventRegistrationId:", eventRegistrationId);
    if (!eventRegistrationId) return;
    get(`/api/academy/events/registration/${eventRegistrationId}/courses?page=${page}&size=10`)
      .then((response) => setCoursesData(response.data))
      .catch((error) => console.error("Error loading courses:", error));
  }, [ configId, eventRegistrationId, page]);
  

  // Mensaje de ayuda temporal
  useEffect(() => {
    const timer = setTimeout(() => setShowHelpMessage(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  // Separar obras becadas y no becadas
  const becadas = performancesData?.content?.filter(p => p.isScholarship) || [];
  const noBecadas = performancesData?.content?.filter(p => !p.isScholarship) || [];

  // Calcular totales
  const totalObras = noBecadas.reduce((acc, performance) => acc + (performance.totalPrice || 0), 0);
  const totalCursos = coursesData?.content?.reduce((acc, course) => acc + (course.totalPrice || 0), 0) || 0;
  const totalGeneral = totalObras + totalCursos;
 

  const hoy = new Date();
  let amount = totalGeneral; // Asumiendo que ya tienes totalGeneral calculado
  let description = "Pago normal";

  if (discountPercentage > 0) {
    // Lógica para aplicar descuento
    amount = totalGeneral * (1 - discountPercentage / 100);
    description = `Pago con ${discountPercentage}% de descuento`;
  } else if (interestPercentage > 0) {
    // Lógica para aplicar interés
    amount = totalGeneral * (1 + interestPercentage / 100);
    description = `Pago con ${interestPercentage}% de recargo`;
  };


  
  
  


  return (
    <Container className="mt-4 pb-5">
      {showHelpMessage && (
        <Alert variant="info" className="text-center">
          Ayuda: Aquí tiene la lista de Obras con su precio y el valor total por pagar
        </Alert>
      )}

      <h2 className="text-center fw-bold">Detalle de pagos Obras y Seminarios</h2>

      {/* Tabla de Obras NO Becadas */}
      <h5 className="text-center mt-4">Obras</h5>
      <Table striped bordered hover className="text-center">
        <thead className="table-primary">
          <tr>
            <th>Orden</th>
            <th>Nombre</th>
            <th>Categoría</th>
            <th>Modalidad</th>
            <th>Forma</th>
            <th>Precio</th>
          </tr>
        </thead>
        <tbody>
          {noBecadas
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((performance, index) => (
              <tr key={`${performance.id}-${index}`}>
                <td className="fw-bold">{performance.order}</td>
                <td>{performance.name}</td>
                <td>{performance.category?.name || "N/A"}</td>
                <td>{performance.modality?.name || "N/A"}</td>
                <td>{performance.form?.name || "N/A"}</td>
                <td>$ {performance.totalPrice || "N/A"}</td>
              </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="fw-bold table-secondary">
            <td colSpan="5" className="text-end">Total Obras:</td>
            <td>$ {totalObras}</td>
          </tr>
        </tfoot>
      </Table>

      {/* Tabla de Obras Becadas */}
      {becadas.length > 0 && (
        <>
          <h5 className="text-center mt-4">Obras Becadas (no se incluyen en el total)</h5>
          <Table striped bordered hover className="text-center">
            <thead className="table-warning">
              <tr>
                <th>Orden</th>
                <th>Nombre</th>
                <th>Categoría</th>
                <th>Modalidad</th>
                <th>Forma</th>
                <th>Precio</th>
              </tr>
            </thead>
            <tbody>
              {becadas
                .slice()
                .sort((a, b) => a.order - b.order)
                .map((performance, index) => (
                  <tr key={`${performance.id}-${index}`}>
                    <td className="fw-bold">{performance.order}</td>
                    <td>{performance.name}</td>
                    <td>{performance.category?.name || "N/A"}</td>
                    <td>{performance.modality?.name || "N/A"}</td>
                    <td>{performance.form?.name || "N/A"}</td>
                    <td>$ {performance.totalPrice || "N/A"}</td>
                  </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}

      {/* Tabla de Seminarios / Congresos */}
      <h5 className="text-center mt-4">Seminarios / Congresos</h5>
<Table striped bordered hover className="text-center">
  <thead className="table-primary">
    <tr>
      <th>Nombre del Seminario / Congreso</th>
      <th>Participantes</th>
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    {coursesData?.content?.map((curso) => (
      <tr key={curso.id}>
        <td>{curso.course?.name}</td>
        <td className="text-start">
          <ol className="mb-0">
          {curso.participants?.map((p, idx) => (
            <li key={idx}>
              {p.member?.name || ''} {p.member?.surname || ''}
            </li>
          ))}
          </ol>
        </td>
        <td>$ {curso.totalPrice?.toLocaleString()}</td>
      </tr>
    ))}
  </tbody>
  <tfoot>
    <tr className="fw-bold table-secondary">
      <td colSpan="2" className="text-end">Total Seminarios:</td>
      <td>$ {totalCursos.toLocaleString()}</td>
    </tr>
  </tfoot>
</Table>


       {/* Total General sin ajustes */}
<h3 className="text-end fw-bold mt-3">
  Total General: $ {totalGeneral.toLocaleString()}
</h3>

{/* Tarjetas de Pago */}
<div className="my-5 d-flex flex-wrap justify-content-center gap-4">
  {paymentConditions?.map((condicion) => {
    const cantidadDeObras = noBecadas.length; // 👈 acá obtenés la cantidad actual

    // Calcular pago solo si hay datos
    const { amount, description } = calcularPago(condicion, cantidadDeObras);

    // No mostrar tarjeta si no se pudo calcular
    if (!amount || !description) {
      return null;
    }

    // Detectar tipo y colores
    let tipo = "normal";
    let headerColor = "bg-primary"; // azul por defecto
    let icono = "ℹ️";

    // Descuento SOLO si cumple cantidad de obras
    if (condicion.discountPercentage > 0 && cantidadDeObras >= condicion.minPerformances) {
      tipo = "descuento";
      headerColor = "bg-success"; // verde
      icono = "✅";
    } 
    // Recargo si tiene interés
    else if (condicion.interestPercentage > 0) {
      tipo = "recargo";
      headerColor = "bg-danger"; // rojo
      icono = "❌";
    }

    return (
      <Card key={condicion.id} style={{ width: '28rem' }} className="shadow rounded-4">
        <Card.Header className={`${headerColor} text-white text-center fw-bold fs-4`}>
          {icono} {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
        </Card.Header>

        <Card.Body className="px-4">
          {condicion.startDate && (
            <Card.Text className="mb-4">
              <strong>Fecha de inicio de condiciones:</strong><br />
              {new Date(condicion.startDate).toLocaleDateString()}
            </Card.Text>
          )}
          <hr />
          <Card.Text className="mb-4">
            <strong>Pago a realizar:</strong><br />
            <span className="text-success fs-3">$ {amount.toLocaleString()}</span>
          </Card.Text>
          <hr />
          <Card.Text>
            <strong>Descripción:</strong><br />
            {description}
          </Card.Text>
        </Card.Body>
      </Card>
    );
  })}
</div>


    </Container>
);

};
export default Payments;
